
  import { computed, defineComponent, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useStore } from 'vuex';
  import moment from 'moment';

  export default defineComponent({
    name: 'auction-properties-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<any>({
        dateFrom: '',
        dateTo: '',
        areaId: '',
        size: '',
        startingPrice: '',
        salePrice: '',
        auctionStatus: '',
        propertyTypeId: '',
        statusId: '',
        descriptionId: '',
        block: '',
        plot: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        if (selectedItems.value.dateFrom) {
          selectedItems.value.dateFrom = moment(
            selectedItems.value.dateFrom
          ).format('YYYY-MM-DD');
        }
        if (selectedItems.value.dateTo) {
          selectedItems.value.dateTo = moment(
            selectedItems.value.dateTo
          ).format('YYYY-MM-DD');
        }
        emit('type-selected', { ...selectedItems.value });
      };

      const onReset = () => {
        selectedItems.value = {
          type: '',
          dateFrom: '',
          dateTo: '',
          areaId: '',
          propertyTypeId: '',
          size: '',
          startingPrice: '',
          salePrice: '',
          statusId: '',
          descriptionId: '',
          block: '',
          plot: '',
        };
        emit('reset', { ...selectedItems.value });
      };

      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_AUCTION_STATUSES);
        await store.dispatch(Actions.GET_ALL_AREAS_LIST, { type: 'auction' });
        await store.dispatch(Actions.GET_ALL_AUCTION_ORGANISERS);
        await store.dispatch(Actions.GET_ALL_AUCTION_DESCRIPTIONS),
          await store.dispatch(Actions.GET_ALL_AUCTION_PROPERTY_TYPES);
        await store.dispatch(Actions.GET_ALL_AUCTIONS_PROPERTY_GROUPINGS);
      });

      return {
        areas: computed(() => store.getters.allListAreas || []),
        auctionStatuses: computed(
          () => store.getters.auctionStatusesList || []
        ),
        organaises: computed(() => store.getters.auctionOrganisesList || []),
        prpertyTypes: computed(
          () => store.getters.allAuctionPropertyTypes || []
        ),
        propertyDescriptions: computed(
          () => store.getters.allAuctionsDescriptionsList
        ),
        translate,
        selectedItems,
        onSubmit,
        onReset,
      };
    },
  });
